import { SEARCH_SEARCH_AUTHORS_SET_DATA } from 'rebook/apps/search/constants';


const initialState = {
  authorsList: null,
  authorsCount: null,
  query: null,
  pageNumber: 1,
  lastPageNumber: 1,
  isLoading: true,
};

export default function searchAuthors(state = initialState, action) {
  switch (action.type) {
    case SEARCH_SEARCH_AUTHORS_SET_DATA:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
}
